import cs from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileProgressBar.scss'
import { wixMobileStepProgressBarDataHooks as dataHooks } from './WixMobileStepProgressBar.dataHooks'

interface WixMobileStepProgressBarProps {
  total: number
  current: number
  dataHook?: string
}

export const WixMobileStepProgressBar: FC<WixMobileStepProgressBarProps> = ({ total, current, dataHook }) => {
  return (
    <div
      role="progressbar"
      aria-valuenow={current}
      aria-valuemin={1}
      aria-valuemax={total}
      className={s.container}
      data-hook={dataHook}
    >
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === current - 1
        return (
          <div
            className={cs(s.pill, { [s.active]: isActive })}
            key={index}
            data-hook={dataHooks.step({ number: index + 1, isActive })}
          />
        )
      })}
    </div>
  )
}
